/**
 * Helpers para extrair dados do envelope padrão da API { data, meta }.
 * Evita repetição de casts nos services.
 */

export interface PagyMeta {
  count: number
  pages: number
  page: number
  items: number
}

export const DEFAULT_PAGY: PagyMeta = {
  count: 0,
  pages: 1,
  page: 1,
  items: 10,
}

/**
 * Extrai o corpo "data" da resposta (envelope ou resposta direta).
 */
export function extractData(res: unknown): unknown {
  return (res as { data?: unknown })?.data ?? res
}

/**
 * Extrai recurso nomeado do data (ex.: data.team, data.accounts) ou o próprio data.
 */
export function extractWrapped<T>(data: unknown, key: string): T {
  const record = data as Record<string, T>
  if (record?.[key] !== undefined) return record[key]
  return (data as T) ?? (data as T)
}

/**
 * Tenta extrair array por uma das chaves; fallback [].
 */
export function extractArray<T>(data: unknown, keys: string[]): T[] {
  const record = data as Record<string, unknown>
  for (const key of keys) {
    const val = record?.[key]
    if (Array.isArray(val)) return val as T[]
  }
  const asArr = data as T[]
  if (Array.isArray(asArr)) return asArr
  return []
}

/**
 * Extrai meta de paginação (pagy) do meta da resposta; fallback DEFAULT_PAGY.
 */
export function extractPagy(meta: unknown): PagyMeta {
  const pagy = (meta as { pagy?: PagyMeta })?.pagy
  return pagy ?? DEFAULT_PAGY
}
